import * as types from '../mutation-types';
import Notifications from '../../notifications';

const state = () => ({
	notifications: [],
	count: 0,
});

const actions = {
	fetchAll({commit}) {
		return axios.get('/api/notifications/all').then(response => {
			commit(types.STORE_ALL_NOTIFICATIONS, response.data);
		});
	},

	fetchCount({commit}) {
		return axios.get('/api/notifications/unread/count').then(response => {
			commit(types.STORE_NOTIFICATIONS_COUNT, response.data);
		});
	},
	
    read({commit}, {notification_id}) {
		return axios.post(`/api/notifications/${notification_id}/read`).then(() => {
			commit(types.MARK_NOTIFICATION_AS_READ, notification_id);
		});
	},
	
	markAllAsRead({commit}) {
		return axios.post('/api/notifications/read').then(() => {
			commit(types.MARK_ALL_NOTIFICATIOSN_AS_READ);
		});
	}
};

const mutations = {
	[types.STORE_ALL_NOTIFICATIONS](state, notifications) {
		for (let notification of notifications) 
			notification.formatted_content = Notifications.getNotificationText(notification.data, notification.type);
		state.notifications = notifications;
		state.count = notifications.filter(c => c.read_at == null).length;
    },
    
    [types.MARK_NOTIFICATION_AS_READ](state, notification_id) {
		state.notifications.find(c => c.id == notification_id).read_at = Date.now();
		state.count--;
	},

	[types.MARK_ALL_NOTIFICATIOSN_AS_READ](state) {
		for (let notification of state.notifications) {
			notification.read_at = Date.now();
		}
		state.count = 0;
	},

	[types.STORE_NOTIFICATIONS_COUNT](state, count) {
		state.count = count;
	}
};

const getters = {
    //
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};